<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Comentario</h5>
      </div>
      <div class="modal-body">
        <p>Comentario: 
          {{ comment.comment }}
        </p>
        <h7>Registrado: {{ comment.created_at }}</h7>
      </div>
      <div class="modal-footer">
        <button class="close-modal-btn" @click="$emit('close')">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    comment: {
      type: [Object, Array],
      default: null,
    },
  },
};
</script>

<style>
/* Estilos para el fondo del modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Contenedor del contenido del modal */
.modal-content {
  background: white;
  width: 80%;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Encabezado del modal */
.modal-header {
  background: #1d4745 !important;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

/* Botón de cerrar */
.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

/* Cuerpo del modal */
.modal-body {
  padding: 20px;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

/* Pie del modal */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #ddd;
}

/* Botón para cerrar el modal */
.close-modal-btn {
  background-color: #1d4745;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}
.close-modal-btn:hover {
  background-color: #1d4745;
}
</style>
